import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Auto-recover from stale webpack chunks after a deploy/hot-reload.
// The browser may hold an old bundle whose module map no longer matches
// freshly emitted chunks (ChunkLoadError / "Cannot find module ./node_modules/..."
// / "Unexpected token '<'" when a deleted chunk is answered with index.html).
// Reload at most once per minute to avoid a reload loop (blinking page).
const RELOAD_FLAG = "fbc_chunk_reload_attempted";
function isStaleChunkError(msg) {
  if (!msg) return false;
  const m = String(msg);
  return (
    m.includes("ChunkLoadError") ||
    m.includes("Loading chunk") ||
    m.includes("Loading CSS chunk") ||
    m.includes("Cannot find module './node_modules/") ||
    // Deleted chunk after a deploy: server returns index.html, parsed as JS
    m.includes("Unexpected token '<'") ||
    m.includes('Unexpected token "<"') ||
    m.includes("expected expression, got '<'")
  );
}
function tryRecover(msg) {
  if (!isStaleChunkError(msg)) return;
  // Cooldown (not once-per-session) so a later deploy can still self-heal,
  // while a persistently broken chunk can't cause a reload loop.
  const last = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
  if (Date.now() - last < 60000) return;
  sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
  window.location.reload();
}
window.addEventListener("error", (event) => {
  tryRecover(event?.error?.message || event?.message);
});
window.addEventListener("unhandledrejection", (event) => {
  tryRecover(event?.reason?.message || event?.reason);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
